new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');
            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                var inputElement = document.getElementById("valorParaCopiar");
                if (inputElement) {
                    var newValueInput = inputElement.value.replace(/^\/\//, '');
                    inputElement.value = newValueInput

                    if (formButton) {
                        formButton.addEventListener("click", (e) => {
                            e.preventDefault();

                            inputElement.select();

                            document.execCommand("copy");

                            window.getSelection().removeAllRanges();

                            alert("Valor copiado: " + newValueInput);
                        });
                    }
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.first-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('.product_list');
        if (vitrineCarrousel) {
            $('.product_list').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });

            $('.product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('.product_list-2');
        if (vitrineCarrousel) {
            $('.product_list-2').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });

            $('.product_list-2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('.product_list-3');
        if (vitrineCarrousel) {
            $('.product_list-3').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });

            $('.product_list-3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.categories').then(element => {
        if (window.matchMedia("(max-width: 991px)").matches) {
            const categoriesHome = document.querySelector('.home .categories');
            if (categoriesHome) {
                $('#categories-home-carrousel').slick({
                    arrows: false,
                    infinite: true,
                    autoplay: true,
                    dots: false,
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 1000,
                    autoplaySpeed: 3000,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: 'unslick'
                        }
                    ]
                });
            }
        }
        if (window.matchMedia("(min-width: 992px)").matches) {
            const categoresItem = document.querySelectorAll('.home .categories .categories-item');
            if (categoresItem.length >= 5) {
                $(document).ready(function () {
                    function initSlick() {
                        const $carousel = $('#categories-home-carrousel');
                        const itemCount = $carousel.children().length;
                        const windowWidth = window.innerWidth;

                        // Destroi o Slick se já estiver ativo
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('unslick');
                        }

                        $carousel.slick({
                            arrows: false,
                            infinite: true,
                            dots: false,
                            mobileFirst: true,
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            speed: 1000,
                            autoplay: true,
                            autoplaySpeed: 1000
                        });
                    }

                    // Inicializa o Slick quando a página é carregada
                    initSlick();

                    // Reativa ou desativa o Slick ao redimensionar a janela
                    $(window).on('resize', function () {
                        initSlick();
                    });
                });

            }
        }
    });

    waitForElementToExist('.faixa-comunicado').then(element => {
        const banner = element.querySelector('#faixa-comunicado');

        if (banner) {
            $('#faixa-comunicado').slick({
                arrows: false,
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    waitForElementToExist('#banner-instagram').then(element => {
        $('#banner-instagram').slick({
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            delay: 5000,
            speed: 700,

            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.four-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list4');
        if (vitrineCarrousel) {
            $('#product_list4').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list4').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.five-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list5');
        if (vitrineCarrousel) {
            $('#product_list5').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list5').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.six-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list6');
        if (vitrineCarrousel) {
            $('#product_list6').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list6').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.seven-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list7');
        if (vitrineCarrousel) {
            $('#product_list7').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list7').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.banner-full').then(element => {
        $('.banner-full-content').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
        });
    });

});